// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expander-panel {
    border: 1px solid #ccc;
}

.expander-header {
    width: 100%;
    display: block;
}

.expander-header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

    .expander-header-content > span {
        text-align: start;
    }

.expander-icon {
    margin-right: 0.5em;
}

.expander-title {
    flex-grow: 1;
}

.expander-indicator {
    margin-left: 0.5em;
    transition-delay: 500ms;
    transition-duration: 250ms;
    transition-timing-function: ease;
    transform-origin: 50% 50%;
}

    .expander-indicator.expanded {
        transform: rotate(180deg);
    }
/* Body animation */
.expander-body {
    overflow: hidden;
    transition: max-height 250ms ease;
    transition-delay: 250ms;
    max-height: 0;
}

    .expander-body.expanded {
        max-height: fit-content; /* large enough to fit content */
        transition-delay: 0ms;
    }

.expander-body-content {
    margin: 1em;
    transition: opacity 250ms ease;
    opacity: 0;
}

    .expander-body-content.expanded {
        opacity: 1;
        transition-delay: 250ms;
    }
`, "",{"version":3,"sources":["webpack://./src/Controls/css/ExpanderPanel.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;IAEI;QACI,iBAAiB;IACrB;;AAEJ;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,gCAAgC;IAChC,yBAAyB;AAC7B;;IAEI;QACI,yBAAyB;IAC7B;AACJ,mBAAmB;AACnB;IACI,gBAAgB;IAChB,iCAAiC;IACjC,uBAAuB;IACvB,aAAa;AACjB;;IAEI;QACI,uBAAuB,EAAE,gCAAgC;QACzD,qBAAqB;IACzB;;AAEJ;IACI,WAAW;IACX,8BAA8B;IAC9B,UAAU;AACd;;IAEI;QACI,UAAU;QACV,uBAAuB;IAC3B","sourcesContent":[".expander-panel {\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n.expander-header {\r\n    width: 100%;\r\n    display: block;\r\n}\r\n\r\n.expander-header-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n    .expander-header-content > span {\r\n        text-align: start;\r\n    }\r\n\r\n.expander-icon {\r\n    margin-right: 0.5em;\r\n}\r\n\r\n.expander-title {\r\n    flex-grow: 1;\r\n}\r\n\r\n.expander-indicator {\r\n    margin-left: 0.5em;\r\n    transition-delay: 500ms;\r\n    transition-duration: 250ms;\r\n    transition-timing-function: ease;\r\n    transform-origin: 50% 50%;\r\n}\r\n\r\n    .expander-indicator.expanded {\r\n        transform: rotate(180deg);\r\n    }\r\n/* Body animation */\r\n.expander-body {\r\n    overflow: hidden;\r\n    transition: max-height 250ms ease;\r\n    transition-delay: 250ms;\r\n    max-height: 0;\r\n}\r\n\r\n    .expander-body.expanded {\r\n        max-height: fit-content; /* large enough to fit content */\r\n        transition-delay: 0ms;\r\n    }\r\n\r\n.expander-body-content {\r\n    margin: 1em;\r\n    transition: opacity 250ms ease;\r\n    opacity: 0;\r\n}\r\n\r\n    .expander-body-content.expanded {\r\n        opacity: 1;\r\n        transition-delay: 250ms;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
